/**
 * Get token from local storage
 * @returns {String | null} token
 */
export const getToken = () => {
    return localStorage.getItem("token");
  };
  